import { connect } from "react-redux";
import moment from 'moment';
import ReadingLevelFormat from "../../../lib/academic/ReadingLevelFormat";
import StudentMetrics from "../../../lib/data/StudentMetrics";

var ReactTooltip = require("react-tooltip");

var BraveCheckbox = require("components/utility/BraveCheckbox");
var Modal = require("components/utility/AltModal");
var StudentDisplay = require("components/users/students/StudentDisplay");
var Glyphicon = require("components/utility/icons/Glyphicon");
var DropDownOptions = require("components/utility/DropDownOptions");
var ToggleMultiselect = require("components/utility/inputs/ToggleMultiselect");
var HelpSectionLink = require('components/utility/HelpSectionLink');
var Spinner = require("components/utility/Spinner");
var EditableGoals = require("components/org/roster/EditableGoals");
var DeleteStudentModal = require("components/org/roster/DeleteStudentModal");

var GradeLevel = require("lib/academic/GradeLevel");
var CurrentUser = require("lib/account/CurrentUser");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");
var DemoAccountSwitcher = require("lib/account/DemoAccountSwitcher");

const INACTIVE_PRIMARY_SL = "inactive_primary_sl"
const NON_PRIMARY_SL = "non_primary_sl"
const NO_PRIMARY_SL = "no_primary_sl"
const PRIMARY_SL = "primary_sl"
@connect(
	(state, props) => {
		var downProps = {
			currentAdmin: RosterSelectors.admin({ state, id: CurrentUser.get().id }),
			studentLists: RosterSelectors.studentLists({ state }),
			readingLevelFormat: CurrentUser.get().prefs.reading_level_format,
			isLoadingStudents: RosterSelectors.isLoadingStudentLists({ state })
		}

		var studentListLinkStatus = null
		// Checking:
		// 1. if the student's primary sl is active.
		// 2. if the student primary sl is viewed sl.
		if (!props.student.student_list_ids.primary) {
			studentListLinkStatus = NO_PRIMARY_SL
		} else if (!props.student.student_list_ids.active.includes(props.student.student_list_ids.primary)) { 
			studentListLinkStatus = INACTIVE_PRIMARY_SL
		} else if (props.student.student_list_ids.primary != props.studentList.id) {
			studentListLinkStatus = NON_PRIMARY_SL
		} else {
			studentListLinkStatus = PRIMARY_SL
		}
		
 		downProps.studentListLinkStatus = studentListLinkStatus
		return downProps
	},
	(dispatch, props) => ({
		updateStudent: (update) => {
			return new Promise((resolve, reject) => {
				// manipulate object to send password_plain_text
				if (_.has(update, 'password')) {
					update['password_plain_text'] = update['password']; // Assign new key
					delete update['password']; // Delete old key
				}
				dispatch(RosterActions.updateStudent({ id: props.student.id, update })).then((response) => {
					resolve(response);
				}).catch(() => resolve({ error: true }));
			})
		},
		// updates student in state
		fetchStudent: (id) => {
			return dispatch(RosterActions.fetchStudent({ id, embeds: ["student.password"] }))
		}
	})
)
class RosterStudent extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		// confirms deletion with user
		this.deleteStudentModal = React.createRef();

		this.state = this.getInitialState();
	}

	///////// HELPERS /////////
	
	// returns the sl and student index used for element ids
	// when adding new element, add the index key to end of id
	// for selenium testing
	indexKey() {
		var { slIndex , index } = this.props
		return `sl${slIndex}-stu${index}`
	}

	getInitialState() {
		return {
			showPasswordOverride: false,
			openSectionClass: null,
			showEditForm: false,
			showEditLink: false,
			overrides: {},
			showPasswords: false,
			savingChanges: false,
			ssoShowUserPass: false
		}
	}

	prefs() {
		return this.props.student.prefs;
	}

	// returns current student
	formStudent() {
		return {
			...this.props.student,
			...this.state.overrides,
			prefs: {
				...this.prefs(),
				...this.state.overrides.prefs
			}
		};
	}

	// checks if objects are equal
	objectsEqual(o1, o2) {
		return Object.keys(o1).length === Object.keys(o2).length && Object.keys(o1).every(p => o1[p] === o2[p]);
	}

	// checks if array of objects are equal
	arraysEqual(a1, a2) {
		return a1.length === a2.length && a1.every((o, idx) => this.objectsEqual(o, a2[idx]));
	}

	switchToDemo() {
		DemoAccountSwitcher.switchToStudent(this.props.student);
	}

	isDemoStudent() {
		return this.props.student.demo_for_teacher
	}

	hasCleverUser() {
		return this.props.currentAdmin && this.props.currentAdmin.clever_user ? true : false
	}

	studentCanBeDeleted() {
		return !this.props.isLoadingStudents && !this.hasCleverUser() && !this.isDemoStudent()
	}

	studentCanBeActivated() {
		return !this.props.isLoadingStudents
	}

	///////// STATE MANIPULATORS /////////

	ssoToggleUserPass() {
		this.setState({ ssoShowUserPass: !this.state.ssoShowUserPass })
	}
	// edits student information
	editStudentForm(key, val, callback) {
		this.setState({
			overrides: { ...this.state.overrides, [key]: val }
		}, callback)
	}

	// edits student prefs
	editStudentFormPrefs(change, callback) {
		this.setState({
			overrides: {
				...this.state.overrides,
				prefs: {
					...this.state.overrides.prefs,
					...change
				},
			}
		}, callback)
	}

	///////// DATABASE MANIPULATORS /////////
	saveChanges(e) {
		if (e) { $wr.nope(e); }
		this.setState({ savingChanges: true })
		if (!_.isEmpty(this.state.overrides)) {
			this.props.updateStudent(this.state.overrides).then((response) => {
				var studentResponse = response.students[0];
				if (!studentResponse.errors) {
					window.wrNotifications.triggerDropDownNotification({
						title: "Student Edited!", text: "You have successfully edited a student!",
						icon: "ok-circle"
					})
					// update student data in state
					this.props.fetchStudent(studentResponse.id);
					// reset component state
					this.setState(this.getInitialState());
				} else {
					this.setState({ savingChanges: false })
					window.wrNotifications.triggerDropDownNotification({
						title: "Oops!", text: "Something went wrong and the student was not edited",
						type: "error", icon: "exclamation-sign"
					}, 4000);
				}
			});
		}
	}

	///////// DELETE STUDENT MODAL /////////

	// modal that asks if the user wants student to 
	// be removed from all lists or the current list
	activateDeleteStudentModal(e, student) {
		$wr.nope(e);
		if (student) {
			this.deleteStudentModal.current.show()
		}
	}

	// modal code
	renderDeleteStudentModal() {
		return (
			<Modal headerText={'Are you sure you want to delete this student?'} ref={this.deleteStudentModal}>
				<DeleteStudentModal
					studentList={this.props.studentList}
					onHide={this.hideModal}
					student={this.formStudent()} />
			</Modal>
		)
	}

	// hide modal, reset state
	hideModal() {
		if (this.deleteStudentModal.current) {
			this.deleteStudentModal.current.hide()
		}
		this.setState(this.getInitialState())
	}

	///////// EDIT STUDENT FORM /////////

	// handles the display of the edit student form
	toggleFormStatus() {
		if (this.state.showEditForm) {
			this.setState({ openSectionClass: 'drawerClosed' }, () => {
				// keep this setTimeout function to ensure all 
				// transitions are complete before removing
				setTimeout(function () {
					this.setState({ showEditForm: false });
				}.bind(this), 1500);
			});
		} else {
			this.setState({ showEditForm: true }, () => {
				setTimeout(function () {
					this.setState({ openSectionClass: 'drawerOpen' });
				}.bind(this), 50);
			});
		}
	}

	// manages display of 'Edit Student' link
	showEditStudentLink() {
		this.state.showEditForm ? this.setState({ showEditLink: false }) : this.setState({ showEditLink: true })
	}


	// allows admin ot override password
	openPasswordOverride() {
		this.setState({ showPasswordOverride: true })
	}

	// manages if the full passwords are displayed
	togglePasswordDisplay() {
		this.setState({ showPasswords: !this.state.showPasswords })
	}

	///////// RENDER METHODS /////////

	renderSubgroup() {
		var { student } = this.props;

		if (student && student.prefs && !_.isEmpty(student.prefs.subgroup)) {
			var group = student.prefs.subgroup;
			var tip = "Group " + group.name;
			return (
				<span className="studentGroup">
					<Glyphicon icon={group.icon}
						style={{ color: group.color }} dataTip={tip} />
					<ReactTooltip effect="solid" />
				</span>
			)
		}
	}

	renderStudentListSelector() {
		var student = this.formStudent()

		if (this.hasCleverUser()) {
			var disableClass = "disableEvents"
			var topContent = (
				<div>
					A filled star is a primary class.<br />
					Empty stars are secondary classes.{" "}
					<HelpSectionLink featureName="Primary & Secondary Classes" linkSuffix="360054128371" iconOnly />
				</div>
			)
		} else {
			var topContent = (
				<div>
					Click a class to set it as primary.<br />
					Hold shift & click to set secondary.{" "}
					<HelpSectionLink featureName="Primary & Secondary Classes" linkSuffix="360054128371" iconOnly />
				</div>
			)
		}

		const toggles = [
			{
				key: "primary",
				icon: "star",
				select: ToggleMultiselect.SELECT_LEFT_CLICK,
				primary: true,
				singleton: true
			}, {
				key: "secondary",
				icon: "star-empty",
				select: ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK,
			}
		]

		var options = this.props.studentLists.map(x => ({ key: x.id, text: x.name }));

		var selected = {}
		_.each(student.student_list_ids.active, slID => {
			if (slID === student.student_list_ids.primary) {
				selected[slID] = "primary";
			} else {
				selected[slID] = "secondary";
			}
		})

		var onClassChange = (updatedSelected) => {
			var newStudentListIDs = {
				'active': [],
				'all': _.difference(student.student_list_ids.all, student.student_list_ids.active)
			}
			_.each(updatedSelected, (toggleKey, studentListID) => {
				newStudentListIDs.active.push(parseInt(studentListID));
				newStudentListIDs.all.push(parseInt(studentListID));

				if (toggleKey === "primary") {
					newStudentListIDs.primary = parseInt(studentListID);
				}
			})

			this.editStudentForm("student_list_ids", newStudentListIDs);
		}

		return (
			<ToggleMultiselect className={`classSelector classSelector-${this.indexKey()} ` + disableClass} dropdownDisplay="link"
				topContent={topContent}
				selected={selected}
				toggles={toggles}
				options={options}
				onChange={onClassChange} />
		)
	}

	// These items are editable for non-Clever users
	buildEditableInformation(student) {
		if (student.sso_data && !_.isEmpty(student.sso_data) && !this.state.ssoShowUserPass) {
			var ssoTitle = student.sso_data['google'] ? 'Google Classroom' : 'Clever'
			var ssoToggleUserPassBtn = (
				<label className="inputPair">
					<span className="text"></span>
					<a onClick={this.ssoToggleUserPass}>Show Username & Password</a>
				</label>
			)

			var loginMethod = (
				<label className="inputPair">
					<span className="text">Login Method</span>
					<span id={`ssoTitle-${this.indexKey()}`}>{ssoTitle}</span>
				</label>
			)
		} else {
			var passwordInput = (
				<label className="inputPair">
					<span className="text">Password</span>
					<span className='passwordDisplayInput'>
						<input data-lpignore="true" className='passwordInput' type="text" value={student.password || ''}
							id={`input-password-${this.indexKey()}`}
							onChange={(e) => this.editStudentForm('password', e.target.value)} />
						<a id={`link-toggle-password-${this.indexKey()}`} onClick={this.togglePasswordDisplay}>Hide</a>
					</span>
				</label>
			)

			var usernameInput = (
				<label className="inputPair">
					<span className="text">Username</span>
					<input
						id={`input-username-${this.indexKey()}`}
						data-lpignore="true" type="text" value={student.username}
						onChange={(e) => this.editStudentForm('username', e.target.value)} />
				</label>
			)
		}

		var firstNameInput = (
			<label className="inputPair">
				<span className="text">First Name</span>
				<input
					id={`input-first-name-${this.indexKey()}`}
					data-lpignore="true" type="text" value={student.first_name}
					onChange={(e) => this.editStudentForm('first_name', e.target.value)} />
			</label>
		)

		var lastNameInput = (
			<label className="inputPair">
				<span className="text">Last Name</span>
				<input
					id={`input-last-name-${this.indexKey()}`}
					data-lpignore="true" type="text" value={student.last_name}
					onChange={(e) => this.editStudentForm('last_name', e.target.value)} />
			</label>
		)

		return { passwordInput, firstNameInput, lastNameInput, usernameInput, loginMethod, ssoToggleUserPassBtn }
	}

	// These items are not editable for Clever users
	buildStaticInformation(student) {
		var passwordInput = (			
			<label className="inputPair">
				<span className="text">Password</span>
				<span className='passwordDisplayInput'>
					<span className='passwordInput'>{student.password || ''}</span>
					<a onClick={this.togglePasswordDisplay}>Hide</a>
				</span>
			</label>
		)

		var firstNameInput = (
			<label className="inputPair">
				<span className="text">First Name</span>
				<span>{student.first_name}</span>
			</label>
		)

		var lastNameInput = (
			<label className="inputPair">
				<span className="text">Last Name</span>
				<span>{student.last_name}</span>
			</label>
		)

		var usernameInput = (
			<label className="inputPair">
				<span className="text">Username</span>
				<span>{student.username}</span>
			</label>
		)

		return { passwordInput, firstNameInput, lastNameInput, usernameInput }
	}

	renderReactivateStudentBtn() {
		return this.studentCanBeActivated() ? <div><a className="btn-link reactivateButton" onClick={() => this.editStudentForm('suspended', false, this.saveChanges)}>Reactivate</a></div> : ''
	}

	renderDeleteStudentBtn(student) {
		// student lists must be loaded before delete student modal
		return this.studentCanBeDeleted() ? <div><a className="btn-link deleteButton" onClick={(e) => this.activateDeleteStudentModal(e, student)}>Delete Student</a></div> : ''
	}

	renderDemoStudentBtn(student) {
		return this.isDemoStudent() ? <div><a className="btn-link switchToDemo" onClick={this.switchToDemo}>Switch to Demo</a></div> : ''
	}
	
	// RETURN STUDENT LIST'S EXPECTATIONS METRIC IF EXISTS OR DEFAULT GRADE LEVEL PREFERENCES
	getSLExpectationsMetrics(){
		const student = this.formStudent()
		var gradeLevel = student.prefs.academic_level
		var glMetrics = this.props.studentList.prefs.grade_level_expectations_metrics
		return glMetrics[gradeLevel] || glMetrics['-1']
	}

	renderAccountSection() {
		var student = this.formStudent();

		if (this.hasCleverUser()) {
			var { firstNameInput, lastNameInput } = this.buildEditableInformation(student)
			var { passwordInput, usernameInput } = this.buildStaticInformation(student)
		} else {
			var { passwordInput, firstNameInput, lastNameInput, usernameInput, loginMethod, ssoToggleUserPassBtn } = this.buildEditableInformation(student)
		}
	
		if (this.state.savingChanges) {
			var buttonSection = (<Spinner scale={1} className="buttonSpinner" />)
		} else {
			var buttonSection = (
				<div className="buttons">
					<div><button className="btn btn-link buttonPrimary saveButton" type="submit">Save</button></div>
					{this.renderDeleteStudentBtn(student)}
					{this.renderDemoStudentBtn(student)}
				</div>
			);
		}

		// render spinner while waiting for password to load
		if (passwordInput) {
			if (this.props.isLoadingStudents) {
				var passwordInput = (<Spinner scale={0.5} className="passwordSpinner" />)
			}
			// student has set password
			else if (student.password === null && !this.state.showPasswordOverride) {
				var passwordInput = (<span><span className="passwordSetByStudent">set by student</span><a onClick={this.openPasswordOverride}>Change</a></span>)
			}
			// hide passwords as default
			else if (!this.state.showPasswords) {
				var displayPassword = student.password ? student.password.replace(/./g, '*') : ''
				var passwordInput = (
					<label className="inputPair">
						<span className="text">Password</span>
						<span className='passwordDisplayInput'>
							<input id={`input-password-${this.indexKey()}`} className='passwordInput' type="text" value={displayPassword} disabled />
							<a id={`link-toggle-password-${this.indexKey()}`}
								onClick={this.togglePasswordDisplay}>Show</a>
						</span>
					</label>
				)
			}
		}

		if (student.prefs.academic_level.toString() != this.props.studentList.grade_level){
			var academicGLMismatch = <Glyphicon data-tip data-for='mismatchingIcon' icon="user" className='userGlyph'/>
		}
		if (student.grade_level.toString() != this.props.studentList.grade_level){
			var glMismatch = <Glyphicon data-tip data-for='mismatchingIcon' icon="user" className='userGlyph'/>
		}

		var slGradeLevelExpectations = this.getSLExpectationsMetrics()

		return (
			<form className={"editSection " + this.state.openSectionClass} onSubmit={this.saveChanges}>
				<div className="firstCol">
					<div className="accountInfo">
						<div className="studentSectionHeader">Account Information</div>
						{firstNameInput}
						{lastNameInput}
						{usernameInput}
						{passwordInput}
						{loginMethod}
						{ssoToggleUserPassBtn}

						<label className="inputPair">
							<span className="text">Owl Shop</span>
							<select type="text" value={student.prefs.shop_opening_time} id={`select-owlShopHours-${this.indexKey()}`}
								onChange={(e) => this.editStudentFormPrefs({ "shop_opening_time": e.target.value })}>
								{DropDownOptions.Select.OwlShopOpeningTimes()}
							</select>
						</label>

						<label className="inputPair">
							<span className="text">Quizzes</span>
							<select type="text" value={student.prefs.quiz_close_time || "Never close"}
								id={ `select-quizCloseTime-${this.indexKey()}` }
								onChange={(e) => this.editStudentFormPrefs({ "quiz_close_time": e.target.value } )}>
								{DropDownOptions.Select.QuizClosingTimes()}
							</select>
						</label>

						<label className="inputPair">
							<span className="text">Class</span>
							{this.renderStudentListSelector()}
						</label>
					</div>
					<div className="studentLevels">
						<div className="studentSectionHeader">Levels</div>
						<label className="inputPair">
							<span className="text">Grade</span>
							<select type="text" value={student.grade_level}
								id={ `select-grade-${this.indexKey()}` }
								onChange={(e) => this.editStudentForm("grade_level", e.target.value)}>
								{DropDownOptions.Select.GradeLevels()}
							</select>
							{glMismatch}
						</label>

						<label className="inputPair">
							<span className="text">Academic Grade</span>
							<select type="text" value={student.prefs.academic_level}
								id={`select-academic-grade-${this.indexKey()}`}
								onChange={(e) => this.editStudentFormPrefs({ "academic_level": e.target.value })}>
								{DropDownOptions.Select.GradeLevels()}
							</select>
							{academicGLMismatch}
						</label>

						<label className="inputPair">
							<span className="text">Reading Level</span>
							<select value={student.current_reading_level}
								id={`select-reading-level-${this.indexKey()}`}
								onChange={(e) => this.editStudentForm("current_reading_level", e.target.value)}>
								{DropDownOptions.Select.ReadingLevels({ lexile_to_formats: this.props.readingLevelFormat, current_reading_level: student.current_reading_level }).slice(0, -1)}
							</select>
						</label>
						<ReactTooltip id="mismatchingIcon" > This student's grade level does not match the class grade level.</ReactTooltip>
					</div>
				</div>
				<div className="secondCol">
					<EditableGoals
						indexKey={`${this.indexKey()}`}
						slExpectations={slGradeLevelExpectations}
						slExpectationTimePeriod={this.props.studentList.prefs.expectations_time_period}
						prefs={student.prefs}
						gradeLevel={student.prefs.academic_level.toString()}
						onEditPrefs={this.editStudentFormPrefs}
						quiz
						student />
					<EditableGoals
						indexKey={`${this.indexKey()}`}
						slExpectations={slGradeLevelExpectations}
						slExpectationTimePeriod={this.props.studentList.prefs.expectations_time_period}
						prefs={student.prefs}
						gradeLevel={student.prefs.academic_level.toString()}
						onEditPrefs={this.editStudentFormPrefs}
						supplemental
						student />
				</div>
				<div className="thirdCol">
					<div className="hideBtn">
						<a className="btn btn-link" onClick={this.toggleFormStatus}>Hide <Glyphicon icon={'menu-up'} /></a>
					</div>
					<div className="btnContainer">
						{buttonSection}
					</div>
				</div>
			</form>

		);
	}

	renderStudentListStatus(student){
		if (this.props.studentListLinkStatus == NON_PRIMARY_SL) {
			var type = "link"
			var toolTip = `${this.props.studentList.name} is a secondary student list for the student.`
			var className = "grey"
		} else if (this.props.studentListLinkStatus == INACTIVE_PRIMARY_SL) {
			var type = "exclamation-sign"
			var toolTip = "This student's primary student list is archived." 
			var className = "red"
		} else if (this.props.studentListLinkStatus == NO_PRIMARY_SL){
			var type = "exclamation-sign"
			var toolTip = "This student has no primary student list." 
			var className = "red"
		} else {
			var type = "link"
			var toolTip = `${this.props.studentList.name} is the student's primary student list.`
			var className="blue primaryLink"
		}

		return (
			<div className={'detailSection narrow ' + className}>
				<Glyphicon icon={type} dataTip={toolTip}/>
			</div>
		)
	}

	renderGoalsSection(student) {
		if (student.suspended) {
			return (
				<div className="detailSection">
					{this.renderDeleteStudentBtn(student)}
				</div>
			)
		} else {
			var studentPrefs = student.prefs
			var studentListPrefs = this.props.studentList.prefs
			if (studentPrefs && studentListPrefs) {

				var stuExpectationCount = _.size(studentPrefs.expectations_metrics)

				if (stuExpectationCount >= 4) {
					var mainText = "All 4 goals assigned"
				} else {
					var goalPluralized = stuExpectationCount < 2 ? "goal" : "goals"
					var mainText = "" + stuExpectationCount + " " + goalPluralized + " assigned, " + (4 - stuExpectationCount) + " remain"
				}
				if (!this.arraysEqual(studentPrefs.expectations_metrics, studentListPrefs.expectations_metrics)) {
					var userIcon = <Glyphicon className="userIcon" icon="user" />
				}

				return (
					<div className="detailSection">
						{mainText}
						{userIcon}
					</div>

				);
			}
		}
	}

	renderLevelsSection(student) {
		if (student.suspended) {
			var content = this.renderReactivateStudentBtn()
		} else {
			if (student.prefs.academic_level.toString() != this.props.studentList.grade_level || 
				student.grade_level.toString() != this.props.studentList.grade_level) {
				var icon = <Glyphicon className='mismatchingGL' icon="user" />
			}
			var content = (
				<div className='gradeLevelContainer'>
					<span>
						{GradeLevel.getShortName(student.grade_level)} grade
					</span>
					{icon}
				</div>
			)
		}
		return (
			<div className="detailSection">
				{content}
			</div>
		);
	}

	renderEditIcon(student) {
		if (this.state.showEditLink) {
			return <Glyphicon className="editIcon" icon="edit" />
		}
	}

	renderCollapsedView(student) {
		if (student.suspended) {
			var lastActive = (
				<span className="lastActive"><strong>Deactivated Student</strong></span>
			)
		}
		else if (this.isDemoStudent()) {
			var lastActive = (
				<span className="lastActive"><strong>Demo Account</strong></span>
			)
		}
		else if (student.last_active) {
			var activeDate = moment(student.last_active).format("M/DD/YY")
			var lastActive = (
				<span className="lastActive">Last Active: {activeDate}</span>
			)
		} else {
			var lastActive = (
				<span className="noActivity">No Activity</span>
			)
		}

		var statSectionClass = this.state.showEditLink ? 'statSection truncate' : 'statSection fullLength'
		return (
			<div className={statSectionClass}>
				{this.renderStudentListStatus(student)}
				<div className="detailSection">
					{lastActive}
				</div>
				{this.renderLevelsSection(student)}
				{this.renderGoalsSection(student)}
			</div>
		)
	}

	renderSuspendedStudentDisplay() {
		var { student } = this.props;

		return (
			<div className="studentListMultiselect" id={`studentListMultiselect-${this.indexKey()}`}>
				<div className="checkboxSection">
					<BraveCheckbox value={this.props.selected} onClick={this.props.toggleSelected} />
				</div>
				<div className="topRow suspended">
					<div className="studentInfo"
						id={`studentInfo-${this.indexKey()}`}
						onClick={this.toggleFormStatus} >
						<div className="nameSection">
							<StudentDisplay studentID={student.id} showAvatar avatarMaxWidth={50} />
						</div>
						{this.renderCollapsedView(student)}
					</div>
				</div>
				{this.renderDeleteStudentModal()}
			</div>
		);
	}

	renderActiveStudentDisplay() {
		var { student } = this.props;

		if (this.state.showEditForm) {
			var selectedEditSection = this.renderAccountSection();
		}

		return (
			<div className="studentListMultiselect"
				id={`studentListMultiselect-${this.indexKey()}`}
				onMouseOver={this.showEditStudentLink}
				onMouseLeave={() => this.setState({ showEditLink: false })}
			>
				<div className="checkboxSection">
					<BraveCheckbox value={this.props.selected} onClick={this.props.toggleSelected} />
				</div>
				<div className="topRow clickableElement">
					<div className="studentInfo"
						id={`studentInfo-${this.indexKey()}`}
						onClick={this.toggleFormStatus}>
						<div className="nameSection">
							<StudentDisplay studentID={student.id} showAvatar avatarMaxWidth={50} />
							{this.renderSubgroup()}
						</div>
						{this.renderCollapsedView(student)}
						{this.renderEditIcon(student)}
					</div>
				</div>
				{/* {this.renderToggleButton()} */}
				{selectedEditSection}
				{this.renderDeleteStudentModal()}
			</div>
		);
	}

	render() {
		var { student } = this.props;

		return student.suspended ? this.renderSuspendedStudentDisplay() : this.renderActiveStudentDisplay()
	}
}

RosterStudent.WrappedComponent.propTypes = PageStrictPropTypes({
	// From above
	student: PropTypes.object.isRequired,
	currentAdmin: PropTypes.object,
	selected: PropTypes.bool,
	studentListLinkStatus: PropTypes.string,
	toggleSelected: PropTypes.func,
	updateStudents: PropTypes.func,
	index: PropTypes.number,
	slIndex: PropTypes.number,

	// @connect data
	populateData: PropTypes.func,
	studentLists: PropTypes.array,
	readingLevelFormat: PropTypes.string,
	isLoadingStudents: PropTypes.bool,
	studentList: PropTypes.object,

	// @connect handlers
	updateStudent: PropTypes.func,
	fetchStudent: PropTypes.func,
});

module.exports = RosterStudent;


// WEBPACK FOOTER //
// ./modules/components/org/roster/RosterStudent.js